/**
 * Russian locale catalogs for the host app chrome.
 *
 * Mirrors the English shape in `./en.ts` (`typeof appShellEn`). The string
 * values stay close to a game raid-planning UI: short imperatives, Russian
 * sentence order, and product names / Discord identifiers left untranslated.
 */
import type { LocaleCatalogShape } from '@/shared/i18n'
import type { appShellEn } from './en.ts'

export const appShellRu: LocaleCatalogShape<typeof appShellEn> = {
  page: {
    skipToMain: 'Перейти к основному содержимому',
    primaryNav: 'Основная навигация',
  },
  heading: {
    planner: 'GvG-планировщик',
    calendar: 'Календарь',
    officers: 'Офицеры',
    onboarding: 'Подключение',
    default: 'WWM GvG',
  },
  statusHints: {
    calendar: {
      day: 'День',
      week: 'Неделя',
      currentWeek: 'Текущая неделя',
      closeCalendar: 'Закрыть календарь',
    },
    planner: {
      drag: 'Перетащите, чтобы переместить',
      click: 'Кликните для редактирования',
      newPlayer: 'Новый игрок',
    },
  },
  header: {
    title: 'WWM GvG-планировщик',
    subtitle: 'Where Winds Meet — командный центр гильдии',
    raidPlanning: 'Планирование рейда',
    guildLabel: 'Гильдия',
    planningGuild: 'Гильдия для рейда',
    accessRequestFailed: 'Не удалось запросить доступ к этой гильдии.',
  },
  profileChip: {
    avatarAlt: (displayName: string) => `Аватар ${displayName}`,
    login: 'Войти через Discord',
  },
  profilePopover: {
    dialogLabel: 'Ваш профиль',
    identity: 'Идентификация профиля',
    quickLinks: 'Быстрые ссылки',
    officerOf: 'Офицер гильдий:',
    noOfficer: 'Нет прав офицера.',
    userId: 'user_id',
    discordId: 'discord_id',
    avatarAlt: (displayName: string) => `Аватар ${displayName}`,
    logout: 'Выйти',
  },
  raidRecovery: {
    title: 'Этот рейд больше недоступен.',
    body: 'Возможно, он был удалён или у вас больше нет доступа. Откройте календарь, чтобы выбрать другой рейд.',
    action: 'Открыть календарь',
  },
} as const
